import gsap from 'gsap'
import barba from '@barba/core'
import { smoothScroller, snapToTop } from './smoothScroller.js'
import { preloader } from './preloader.js'
import { navigation } from './navigation.js'
import { animation } from './animation.js'
import { swiper } from './swiper.js'
import { events } from './events.js'
import { map, initMaps } from './map.js'
import { team } from './team.js'
import { contact } from './contact.js'
import { expandText } from './expand-text.js'
import { hexagons } from './hexagons.js'
import { filters } from './filters.js'
import { modals } from './modals.js'
import { totalizer } from './totalizer.js'
import { initAlpine } from './alpine.js'
import { initEventTracking } from './analytics-tracking.js'

const initBarba = () => {

	const initComponents = () => {
		initEventTracking()

		console.log('initComponents')

		snapToTop()
		setTimeout(() => {
			document.body.dataset.preloader = 'in-progress'
		}, 100);
		setTimeout(() => {
			document.body.dataset.preloader = 'complete'
		}, 200);

		initAlpine()
		preloader() 
		smoothScroller()
		navigation()
		events()
		map()
		team()
		expandText()
		hexagons()
		contact()
		setTimeout(() => animation(), 20);
		swiper()
		filters()
		modals()
		setTimeout(() => totalizer(), 600);
	}

	initComponents()

	return

	barba.init({
		debug: false,
		schema: {
			prefix: 'data-load',
		},
		prevent: ({ el }) => el.classList.contains('ab-item'),
		transitions: [{
			name: 'basic-transition',
			once(data) {
				snapToTop()
				setTimeout(() => {
					document.body.dataset.preloader = 'in-progress'
				}, 100);
				setTimeout(() => {
					document.body.dataset.preloader = 'complete'
				}, 200);
			},
			leave(data) {
				let button = document.querySelector('[data-toggle-navigation]'),
					nav = document.querySelector('.site-navigation')
				if (button && nav) {
					button.setAttribute('aria-expanded', 'false')
					button.setAttribute('aria-label', 'Open menu')
					nav.hidden = true
				}
				const done = this.async()
				setTimeout(function () {
					done()
				}, 800)
				return gsap.to(data.current.container, { duration: 0.3, opacity: 0 })
			},
			after(data) {
				snapToTop()
				return gsap.from(data.next.container, { duration: 0.3, opacity: 0 })
			}
		}]
	})

	barba.hooks.once((data) => {
		initAlpine()
		preloader()
		smoothScroller()
		navigation()
		events()
		map()
		team()
		expandText()
		hexagons()
		contact()
		setTimeout(() => animation(), 20);
		swiper()
		filters()
		modals()
		setTimeout(() => totalizer(), 600);
	})

	barba.hooks.after((data) => {
		smoothScroller()
		animation()
		swiper()
		events()
		initMaps()
		team()
		expandText()
		hexagons()
		contact()
		filters()
		modals()
		setTimeout(() => totalizer(), 600);
		const scripts = document.querySelectorAll('main script')
		scripts.forEach((script) => eval(script.innerHTML))
	})

}

export default initBarba